export const getJzImageUrl = (imgName) => {
    return `https://oss.jianzeppt.com/jz-ppt-img/${imgName}`
}
